'use client';
import PublicOffIcon from '@mui/icons-material/PublicOff';
import { Alert, Typography } from '@mui/material';

import { useT } from '@/hooks';
import { useGeoblockStatus } from '@/services/query';

export const GeoBlockBanner = () => {
  const { t } = useT();
  const { data } = useGeoblockStatus();

  if (!data?.blocked) return null;

  return (
    <Alert
      icon={false}
      severity="info"
      sx={(theme) => ({
        borderRadius: 0,
        py: 0.75,
        px: { xs: 2, sm: 4 },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor:
          theme.palette.mode === 'dark' ? 'rgba(56, 139, 253, 0.12)' : 'rgba(25, 118, 210, 0.08)',
        borderBottom: `1px solid ${
          theme.palette.mode === 'dark' ? 'rgba(56, 139, 253, 0.25)' : 'rgba(25, 118, 210, 0.2)'
        }`,
        backdropFilter: 'blur(8px)',
        '& .MuiAlert-message': {
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1,
          padding: 0,
        },
      })}
    >
      <PublicOffIcon
        fontSize="small"
        sx={(theme) => ({
          color: theme.palette.mode === 'dark' ? 'rgba(56, 139, 253, 0.9)' : 'primary.main',
          flexShrink: 0,
        })}
      />
      <Typography
        variant="body2"
        sx={(theme) => ({
          fontWeight: 500,
          fontSize: { xs: '0.75rem', sm: '0.8125rem' },
          color: theme.palette.mode === 'dark' ? 'rgba(56, 139, 253, 0.95)' : 'primary.dark',
          textAlign: 'center',
        })}
      >
        {t('geoBlock.restrictedMessage', {
          location: data?.region ? `${data.country}, ${data.region}` : data?.country,
          defaultValue: `Trading is restricted in your region (${data?.country}${data?.region ? `, ${data?.region}` : ''}). Orders placed may be automatically cancelled.`,
        })}
      </Typography>
    </Alert>
  );
};

export default GeoBlockBanner;
